/** Formats a signed dollar amount, e.g. 12.5 → "+$12.50", -3 → "–$3.00". */
export const formatSignedCurrency = (value: number): string =>
  `${value >= 0 ? '+' : '–'}$${Math.abs(value).toFixed(2)}`;
